module.exports = __webpack_public_path__ + "static/media/roque.9dea08bb.jpeg";